import type { BingoResultToShowType, MetagameBingoEvent } from '../../../../../stores/bingo/types';
import type { BingoWidgetDataType, BingoWidgetType } from '../../../types';

import { BingoLiveWideWidget } from './BingoLiveWideWidget/BingoLiveWideWidget';
import { BingoNewPlayerWideWidget } from './BingoNewPlayerWideWidget/BingoNewPlayerWideWidget';
import { BingoRewardWideWidget } from './BingoRewardWideWidget/BingoRewardWideWidget';
import { BingoStartingSoonWideWidget } from './BingoStartingSoonWideWidget/BingoStartingSoonWideWidget';
import { BingoUpcomingWideWidget } from './BingoUpcomingWideWidget/BingoUpcomingWideWidget';

interface BingoWideWidgetProps {
  data: BingoWidgetDataType;
  widgetType: BingoWidgetType;
  newPlayer?: boolean;
}

export function BingoWideWidget(props: BingoWideWidgetProps) {
  const { widgetType, data, newPlayer } = props;

  if (widgetType === 'reward') {
    return <BingoRewardWideWidget event={data.event as BingoResultToShowType} />;
  }

  if (newPlayer) {
    return <BingoNewPlayerWideWidget data={data} widgetType={widgetType} />;
  }

  switch (widgetType) {
    case 'upcoming':
      return <BingoUpcomingWideWidget />;
    case 'live':
      return <BingoLiveWideWidget event={data.event as MetagameBingoEvent} />;
    case 'startingSoon':
      return <BingoStartingSoonWideWidget event={data.event as MetagameBingoEvent} />;
    default:
      return null;
  }
}
